import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { createApiResponseSchema } from '../../../utils';
import { partnerApiPath } from '../../apiPath';
import { partnerHttpClient } from '../../httpClient';

const GetColorGroupMembersRequestSchema = z
  .object({
    brandId: z.string(),
    platform: z.string(),
    goodsNo: z.number(),
  })
  .describe('GetColorGroupMembersRequestSchema');

export type GetColorGroupMembersRequest = z.infer<typeof GetColorGroupMembersRequestSchema>;

const ColorGroupMemberSchema = z
  .object({
    goodsNo: z.number(),
    goodsName: z.string(),
    category: z.string(),
    price: z.number(),
    imageUrl: z.string(),
    platform: z.string(),
    colorGroupId: z.number().nullable().optional(),
  })
  .describe('ColorGroupMemberSchema');

export type ColorGroupMember = z.infer<typeof ColorGroupMemberSchema>;

const GetColorGroupMembersResponseDataSchema = z
  .object({
    list: z.array(ColorGroupMemberSchema),
  })
  .describe('GetColorGroupMembersResponseDataSchema');

const GetColorGroupMembersResponseSchema = createApiResponseSchema(
  GetColorGroupMembersResponseDataSchema,
);

export type GetColorGroupMembersResponse = z.infer<typeof GetColorGroupMembersResponseSchema>;

export const getColorGroupMembers = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetColorGroupMembersRequestSchema),
    async ({ brandId, ...query }: GetColorGroupMembersRequest) =>
      executeStandardRequest(async () =>
        partnerHttpClient.get<GetColorGroupMembersResponse>(
          partnerApiPath.getBrandProductsColorGroup(brandId),
          query,
        ),
      ),
    validateApiResponse(GetColorGroupMembersResponseSchema),
  ),
);
